module.exports = __webpack_public_path__ + "static/media/logo.c3ce73b6.png";